import _ from 'lodash';

export function makeAddToDictionaryCallback (dict) {
	return function addToDictionary (response) {
		_.each(response, (record) => {
			dict.biset(parseInt(record.value), record.label, true);
		});
		dict.notify();
		return response;
	};
}

export function filterFromDictionary (dict) {
	return (val) => dict.has(val);
}
